exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.prev[data-v-057a907f] {\n  left: 0;\n}\n.next[data-v-057a907f] {\n  right: 0;\n}\n@media (max-width: 450px){\n.history-calendar-box[data-v-057a907f] {\n    flex-flow: nowrap;\n}\n}\n\n", ""]);

// exports
